import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getProjectDetails, clearProjectDetails } from '../../../../redux/Slices/authSlice';

const ProjectDetails = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';
  const { projectDetails } = useSelector((s) => s.auth);

  useEffect(() => {
    dispatch(getProjectDetails(id));
    return () => {
      dispatch(clearProjectDetails());
    };
  }, [dispatch, id]);

  const project = projectDetails || {};

  const renderStatus = (status) => {
    const statusMap = {
      planned: { text: 'مخطط', bg: '#11324D', color: 'white' },
      in_progress: { text: 'قيد التنفيذ', bg: 'rgba(246,99,13,0.3)', color: '#F6630D' },
      paused: { text: 'متوقف', bg: 'rgba(241,196,15,0.3)', color: '#f1c40f' },
      completed: { text: 'مكتمل', bg: 'rgba(39,174,96,0.3)', color: '#27ae60' },
      cancelled: { text: 'ملغى', bg: 'rgba(192,57,43,0.3)', color: '#c0392b' },
    };
    const meta = statusMap[status] || { text: status || '—', bg: '#6c757d', color: 'white' };
    return (
      <span style={{ backgroundColor: meta.bg, color: meta.color || 'white', padding: '4px 12px', borderRadius: 16, fontSize: 12, fontWeight: 'bold', display: 'inline-block', whiteSpace: 'nowrap', minWidth: 100, textAlign: 'center' }}>
        {meta.text}
      </span>
    );
  };

  const formatDate = (val) => (val ? String(val).split('T')[0] : '—');

  return (
    <div style={{ padding: '30px', backgroundColor: '#14263b', minHeight: 'calc(100vh - 80px)', color: 'white' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h1 style={{ margin: 0, fontSize: '20px' }}>تفاصيل المشروع</h1>
        <button onClick={() => navigate('/projects')} style={{ background: '#444', color: 'white', border: 'none', borderRadius: 6, padding: '8px 12px', cursor: 'pointer' }}>
          رجوع
        </button>
      </div>

      <div style={{ background: '#1b3350', border: '1px solid #333', borderRadius: 12, padding: 24 }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: 20 }}>
          <InfoBlock label="الكود" value={project.code} />
          <InfoBlock label="الاسم بالعربية" value={project.name_ar} />
          <InfoBlock label="الاسم بالإنجليزية" value={project.name_en} />
          <InfoBlock label="العميل" value={project.customer?.name_ar || project.customer?.name || '—'} />
          <InfoBlock label="تاريخ البداية" value={formatDate(project.start_date)} />
          <InfoBlock label="تاريخ النهاية" value={formatDate(project.end_date)} />
          <div style={{ padding: '12px 0' }}>
            <strong style={{ display: 'block', marginBottom: 8, color: 'white' }}>الحالة:</strong>
            <span style={{ display: 'block' }}>{renderStatus(project.status)}</span>
          </div>
          <div style={{ padding: '12px 0' }}>
            <strong style={{ display: 'block', marginBottom: 8, color: 'white' }}>تفعيل الحساب:</strong>
            <span style={{ display: 'block' }}>
              <span
                style={{
                  backgroundColor: project.is_active ? '#11324D' : '#3a3f50',
                  color: 'white',
                  padding: '4px 12px',
                  borderRadius: 16,
                  fontSize: 12,
                  fontWeight: 'bold',
                  display: 'inline-flex',
                  minWidth: 100,
                  justifyContent: 'center',
                  alignItems: 'center',
                  textAlign: 'center',
                  whiteSpace: 'nowrap',
                }}
              >
                {project.is_active ? 'مفعل' : 'غير مفعل'}
              </span>
            </span>
          </div>
          <InfoBlock label="قيمة العقد" value={project.contract_value != null ? Number(project.contract_value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '—'} />
          <InfoBlock label="الضريبة" value={project.tax?.name_ar || project.tax?.name_en || '—'} />
          <InfoBlock label="حساب الإيرادات" value={project.revenue_account ? `${project.revenue_account.code || ''} - ${project.revenue_account.name_ar || project.revenue_account.name || ''}` : '—'} />
          <InfoBlock label="حساب قيد التنفيذ" value={project.wip_account ? `${project.wip_account.code || ''} - ${project.wip_account.name_ar || project.wip_account.name || ''}` : '—'} />
          <InfoBlock label="مركز التكلفة" value={project.cost_center ? `${project.cost_center.code || ''} - ${project.cost_center.name_ar || project.cost_center.name || ''}` : '—'} />
          <InfoBlock label="تاريخ الإنشاء" value={formatDate(project.created_at)} />
          <InfoBlock label="تاريخ التحديث" value={formatDate(project.updated_at)} />
          <div style={{ gridColumn: '1 / -1', padding: '12px 0' }}>
            <strong style={{ display: 'block', marginBottom: 8, color: 'white' }}>ملاحظات:</strong>
            <span style={{ display: 'block', color: 'white' }}>{project.notes || '—'}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

const InfoBlock = ({ label, value }) => (
  <div style={{ padding: '12px 0' }}>
    <strong style={{ display: 'block', marginBottom: 8, color: 'white' }}>{label}</strong>
    <span style={{ display: 'block', color: 'white' }}>{value || '—'}</span>
  </div>
);

export default ProjectDetails;

